<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../compositions/CustomList.vue";
import ModalDialog from "../../compositions/ModalDialog.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import TextBox from "../../compositions/TextBox.vue";
import CheckBox from "../../compositions/CheckBox.vue";
import Chart from "../../compositions/Chart.vue";
import OrderHistoryMedicineComponent from "./OrderHistoryMedicineComponent.vue";
import config from "../../config.js";
import { errorAlert } from "../../plugins/alert";
import { getFieldValue } from "../../plugins/utility";
import qs from 'qs';
import axios from '../../plugins/axios.ts';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    optionFields:{
      type:Object,
      required:true,
    },
});

const { optionFields } = toRefs(props);
const listRef = ref();
const listSearch = () => {
  if (typeof listRef.value === 'undefined') {
    return;
  }
  prescriptCount.value = 0;
  listRef.value.resetItem();
}
const fields = ref([
  {field_name: '来局日時', field_key: 'real_prescript_date', width: '10%', align: 'text-center', sorted:true},
  {field_name: '調剤内容', field_key: 'prescript_information', width: '90%', align: 'text-left'},
]);

watch(optionFields,(newValue,oldValue) => {
  listSearch();
},{deep:true});

const prescriptCount = ref(0);
const listResponseComplete = (data) => {
  prescriptCount.value = data.count;
}
</script>

<style scoped>
</style>
<template>
<div>
  <div class="bg-gray-400 text-white p-1">件数：{{ prescriptCount }}</div>
  <custom-list
    ref="listRef"
    :table-fields="fields"
    :option-fields="optionFields"
    :api-url="apis.pharmacy_prescript_list"
    :response-complete="listResponseComplete"
    height="72vh"
  >
  <template v-slot:item="slotProps">
    <td v-for="(field,index) in fields" :key="index" :style="'width:' + field.width" class="text-center">
      <div v-if="field.field_key == 'real_prescript_date'">
        <div>{{ getFieldValue(slotProps.item,field.field_key) }}</div>
        <div v-show="typeof slotProps.item.is_audit !== 'undefined' && slotProps.item.is_audit" class="label-audit-checked text-xs">監査チェック済み</div>
        <div v-show="(typeof slotProps.item.audit_user !== 'undefined') && (typeof slotProps.item.audit_user.username !== 'undefined')" class="text-xs">担当:{{ slotProps.item.audit_user.username }}</div>
      </div>
      <div v-else-if="field.field_key == 'prescript_information'">
        <div class="flex flex-wrap items-center text-left">
          <div class="m-1">
            <i class="fa-regular fa-hospital"></i> {{ slotProps.item.medical_name }} ({{ slotProps.item.department_name }}) <i class="fa-solid fa-user-doctor"></i> {{ slotProps.item.physician_kanji_name }}　<i class="fa-solid fa-user-nurse"></i> {{ slotProps.item.pharmacist_name }}
          </div>
          <div class="m-1 p-2 border rounded">
            患者番号：{{ slotProps.item.patient.patient_no }} <i class="fa-solid fa-user-large"></i> {{ slotProps.item.patient_profile.patient_kanji_name }}({{ slotProps.item.patient_profile.age }}) {{ slotProps.item.patient_profile.gender }}
          </div>
          <div class="m-1 p-2 border rounded">
            <div v-for="prescriptUsage in slotProps.item.prescript_usages" :key="prescriptUsage.id" class="border-b-2 mb-2">
              <div v-for="prescriptMedicine in prescriptUsage.prescript_medicines" :key="prescriptMedicine.id">
                <div>{{ prescriptMedicine.drug_name }} {{ prescriptMedicine.dosage + prescriptMedicine.dosage_unit }}</div>
              </div>
              <div v-html="prescriptUsage.dosage_label + ' ' + prescriptUsage.dosage_frequency_label">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else :class="field.align">
        {{ getFieldValue(slotProps.item,field.field_key) }}
      </div>
    </td>
  </template>
  </custom-list>
</div>
</template>

